var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTicki = function SvgTicki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    d: "M4 12.66 8.85 17 20 7"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTicki);
export default ForwardRef;